// Contains mirror functions to /infra/go/paramtools. See that module for more
// details.
//
// All the validation is done on the server, so these functions do less checking
// on the validity of structured keys and Params.
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    makeKey: function() {
        return makeKey;
    },
    fromKey: function() {
        return fromKey;
    },
    formatSpecialFunctions: function() {
        return formatSpecialFunctions;
    },
    validKey: function() {
        return validKey;
    },
    addParamsToParamSet: function() {
        return addParamsToParamSet;
    },
    paramsToParamSet: function() {
        return paramsToParamSet;
    },
    addParamSet: function() {
        return addParamSet;
    },
    toReadOnlyParamSet: function() {
        return toReadOnlyParamSet;
    },
    queryFromKey: function() {
        return queryFromKey;
    }
});
const _json = require("../json");
function makeKey(params) {
    if (Object.keys(params).length === 0) {
        throw new Error('Params must have at least one entry');
    }
    const keys = Object.keys(params).sort();
    return `,${keys.map((key)=>`${key}=${params[key]}`).join(',')},`;
}
function fromKey(structuredKey, attribute) {
    const k = formatSpecialFunctions(structuredKey);
    const ret = (0, _json.Params)({});
    k.split(',').forEach((keyValue)=>{
        if (!keyValue) {
            return;
        }
        const [key, value] = keyValue.split('=');
        if (key === attribute) {
            return;
        }
        ret[key] = value;
    });
    return ret;
}
function formatSpecialFunctions(key) {
    const funcKeyRegex = new RegExp(/\w+\(,.*,\)/);
    const isFuncKey = key.match(funcKeyRegex);
    // If the key matches the pattern, e.g: norm(,a=1,b=2,c=3,), then extract strings inside
    // the paranthesis
    if (isFuncKey) {
        const keyRegex = new RegExp(RegExp("(?<=\\()(.*?)(?=\\))"));
        extractNonKeyValuePairsInKey(key.match(keyRegex)[0]);
    }
    return extractNonKeyValuePairsInKey(key);
}
function extractNonKeyValuePairsInKey(key) {
    const removeSpecialZeroKey = key.split(',').map((item)=>{
        const equalsIndex = item.indexOf('=');
        // Check if '=' exists
        if (equalsIndex > 0 && equalsIndex < item.length - 1) {
            return `${item.substring(0, equalsIndex)}=${item.substring(equalsIndex + 1)}`;
        }
        // If the item doesn't match the pattern, return null
        return null;
    }).filter((result)=>result !== null);
    return removeSpecialZeroKey.join(',');
}
function validKey(key) {
    return key.startsWith(',') && key.endsWith(',');
}
function addParamsToParamSet(ps, p) {
    Object.entries(p).forEach((keyValue)=>{
        const [key, value] = keyValue;
        let values = ps[key];
        if (!values) {
            values = [];
        }
        if (values.indexOf(value) === -1) {
            values.push(value);
        }
        ps[key] = values;
    });
}
function paramsToParamSet(p) {
    const ret = (0, _json.ParamSet)({});
    Object.entries(p).forEach((value)=>{
        ret[value[0]] = [
            value[1]
        ];
    });
    return ret;
}
function addParamSet(p, ps) {
    for (const [k, arr] of Object.entries(ps)){
        if (!p[k]) {
            p[k] = arr.slice(0);
        } else {
            for (const v of arr){
                if (!p[k].includes(v)) {
                    p[k].push(v);
                }
            }
        }
    }
}
function toReadOnlyParamSet(ps) {
    return ps;
}
function queryFromKey(key) {
    return new URLSearchParams(fromKey(key)).toString();
}
